import { Card } from "antd";
import React from "react";
import { styled } from "styled-components";
import People from "../../../assets/icon/people.svg";
import CardArrow from "../../../assets/cardarrow.svg";
import Economy from "../../../assets//icon/economy.svg";
import University from "../../../assets/icon/university.svg";
import Support from "../../../assets/icon/support.svg";
import Airpot from "../../../assets/icon/airpot.svg";
import { theme } from "shared/src/theme";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { CityData } from "../../../service/citydata";
import Link from "next/link";
import { SeeMoreLess } from "../SeeMoreLess";

const CardContainer = styled.div`
  grid-row-gap: 24px;
  display: grid;
  grid-column-gap: 4%;
  grid-template-columns: 1fr 1fr 1fr;

  & .summary-card .ant-card-body {
    align-items: center;
  }
  & a {
    color: ${theme.textColor};
    font-size: 13px;
    &:hover {
      color: ${theme.buttonRed};
    }
  }
  & .ant-typography-expand {
    color: ${theme.gray1};
    display: block;
    &:hover {
      color: ${theme.buttonRed};
    }
  }
  & .ant-typography {
    margin-left: 10px;
    white-space: break-spaces;
  }
  & h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    color: ${theme.gray0};
    margin-top: 16px;
    border-left: 2px solid ${theme.buttonRed};
    padding-left: 16px;
    min-width: 83px;
  }
  & h1 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    margin: auto;
    line-height: 40px;
    color: ${theme.gray0};
  }

  & ul {
    font-family: Open Sans;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${theme.gray1};
  }
  & h3 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.gray1};
  }

  & .ant-card-body {
    display: flex;
    padding: 24px 16px 26px 0px !important;
    max-width: 384px;
    height: 100%;
    border-radius: 8px;
    border: 1px solid ${theme.gray3};
    @media (max-width: 650px) {
      max-width: 100%;
      /* min-height: 161px; */
    }
    @media (min-width: 1441px) {
      max-width: 100%;
    }
  }

  & .ant-card-bordered {
    border: none;
  }

  @media (min-width: 651px) {
    & .large-card .ant-card-body {
      position: absolute;
      top: 0px;
      display: table;
      width: 100%;
      z-index: 1;
      border: 1px solid ${theme.gray3};
      background: ${theme.base};

      & > div:first-child {
        float: left;
      }

      & > div:last-child {
        display: flex;
        flex-direction: column;
      }
    }
  }

  & .ellipsis-large {
    height: 83px;
    overflow: hidden;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;
const SummaryHeading = styled.strong`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.buttonRed};
  margin: 18px;
`;

const StyledCard = styled(Card)<{ inPoint?: string }>`
  border-radius: 10px;
  background: ${theme.white};
  & ul {
    list-style-type: ${({ inPoint }) => inPoint};
  }
  & .seeMore {
    color: ${theme.buttonRed};
    text-decoration: underline !important;
    cursor: pointer;
    font-size: 13px;
    padding: 0px;
  }
  & .seeLess {
    display: block;
    color: ${theme.buttonRed};
    text-decoration: underline !important;
    cursor: pointer;
    font-size: 13px;
    padding: 0px;
  }
  & .paragraph {
    color: ${theme.buttonRed};
    padding: 0px;
    text-decoration: underline !important;
  }
  & a {
    width: 100%;
    margin: auto;
    margin: 0px !important;
  }
  & .pointWrapper {
    display: flex;
    /* min-height: 118px; */
    justify-content: center;
    @media (max-width: 655px) {
      flex-direction: column;
    }
    & .ant-typography {
      margin-left: 32px;
      margin-bottom: 0px;
    }
    & .list {
      padding: 0px;
      margin-bottom: 0px;
    }
  }
`;

const StyledInfo = styled.div`
  color: #7c837c;
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
`;

const StyledSummaryCard = styled.div`
  border-radius: 10px;
  background: ${theme.white};
  cursor: pointer;
`;
const SummaryIcon = styled.div`
  display: flex;

  align-items: center;
  margin: auto;
  cursor: pointer;
  justify-content: center;

  height: 100%;
  & svg > path {
    fill: ${theme.buttonRed};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
  flex-direction: column;
  justify-content: center;
`;

const Container = styled.div`
  max-width: 1440px;
  margin: auto;
  margin-bottom: 64px;
`;
const ImageWrapper = styled.div`
  height: 64px;
  width: 64px;
  padding-left: 16px;
`;
const ParagrahpWrapper = styled.p`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400px;
  color: ${theme.gray1};
  margin-left: 41px;
  font-size: 14px;
  line-height: 20px;
  overflow-wrap: anywhere;
  margin-top: 0px;
  white-space: break-spaces;
`;
const AirpotWrapper = styled.p`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.gray1};
  margin-left: 32px;
  margin-bottom: 0px;
  white-space: break-spaces;
`;

const UniversityDetails = styled.div`
  & p {
    color: ${theme.gray1};
    margin-bottom: 6px;
  }
  & li {
    white-space: pre-line;
  }
  & span {
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: ${theme.buttonRed};
    }
  }
`;
interface CityCardProps {
  id?: any;
  population?: string;
  economy?: any;
  university?: any;
  support?: any;
  access?: any;
}
export const CityCard = ({ id }: CityCardProps) => {
  const { t } = useTranslation();

  const { data: cityData } = useQuery(["cityData", id], CityData, {
    refetchOnWindowFocus: false,
  });

  return (
    <Container>
      <CardContainer>
        {cityData?.population && (
          <StyledCard>
            <IconWrapper>
              <ImageWrapper>
                <People />
              </ImageWrapper>
              <h2>{t("Population")}</h2>
            </IconWrapper>
            <h1>{cityData?.population}</h1>
          </StyledCard>
        )}
        {cityData?.economy && (
          <StyledCard
            className="large-card"
            inPoint={cityData?.inPoint ? "disc" : "none"}
          >
            <IconWrapper>
              <ImageWrapper>
                <Economy />
              </ImageWrapper>
              <h2>{t("Economy")}</h2>
            </IconWrapper>
            <div className="pointWrapper">
              <ul className="list">
                {cityData?.economy?.split(";")?.map((item, index) => {
                  return (
                    <SeeMoreLess item={item} index={index} key={index + item} />
                  );
                })}
              </ul>
            </div>
          </StyledCard>
        )}
        {cityData?.university && (
          <StyledCard
            className="large-card"
            inPoint={cityData?.inPoint ? "disc" : "none"}
          >
            <IconWrapper>
              <ImageWrapper>
                <University />
              </ImageWrapper>
              <h2>{t("University")}</h2>
            </IconWrapper>
            <UniversityDetails className="pointWrapper">
              <ul className="list">
                {cityData?.university?.split(";")?.map((item, index) => {
                  return (
                    <SeeMoreLess item={item} index={index} key={index + item} />
                  );
                })}
              </ul>
            </UniversityDetails>
          </StyledCard>
        )}
        {cityData?.support && (
          <StyledCard>
            <IconWrapper>
              <ImageWrapper>
                <Support />
              </ImageWrapper>
              <h2>{t("Support")}</h2>
            </IconWrapper>
            <ParagrahpWrapper>
              {cityData?.support}{" "}
              <a target="_blank" href={`mailto:${cityData?.supportEmail}`}>
                {cityData?.supportEmail}
              </a>
            </ParagrahpWrapper>
          </StyledCard>
        )}

        {cityData?.access && (
          <StyledCard>
            <IconWrapper>
              <ImageWrapper>
                <Airpot />
              </ImageWrapper>
              <h2>{t("Access")}</h2>
            </IconWrapper>

            <AirpotWrapper>
              {cityData?.access}
              {cityData?.accessURL ? (
                <a target="_blank" href={cityData.accessURL}>
                  {cityData.accessURL}
                </a>
              ) : null}
            </AirpotWrapper>
          </StyledCard>
        )}
        {cityData?.url && (
          <StyledCard className="summary-card">
            <Link href={`/city${cityData?.url}`} passHref>
              <a target="_blank">
                <StyledSummaryCard>
                  <SummaryIcon>
                    <SummaryHeading>{t("City summary")}</SummaryHeading>
                    <CardArrow />
                  </SummaryIcon>
                </StyledSummaryCard>
              </a>
            </Link>
          </StyledCard>
        )}
      </CardContainer>
      <StyledInfo>{t("* As of August 2022 Public statistics")}</StyledInfo>
    </Container>
  );
};
